import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#home'
  }, {
    name: 'Our Story',
    href: '#story'
  }, {
    name: 'Dairy',
    href: '#dairy'
  }, {
    name: 'Crops',
    href: '#crops'
  }, {
    name: 'Visits',
    href: '#visits'
  }, {
    name: 'Gallery',
    href: '#gallery'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-green-900/95 backdrop-blur-sm shadow-md py-3' : 'bg-transparent py-5'}`} data-id="element-240">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-241">
        <div className="flex justify-between items-center" data-id="element-242">
          {/* Logo */}
          <div className="flex items-center" data-id="element-243">
            <a href="#" className="text-2xl font-bold text-white tracking-tight" data-id="element-244">
              GreenSlopes<span className="text-green-300" data-id="element-245">Farm</span>
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8" data-id="element-246">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-white/90 hover:text-green-300 transition-colors text-sm font-medium uppercase tracking-wide" data-id="element-247">
                {link.name}
              </a>)}
          </nav>

          {/* WhatsApp Button (Desktop) */}
          <div className="hidden md:block" data-id="element-248">
            <a href="https://wa.me/254720934332" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-full text-green-900 bg-green-100 hover:bg-white transition-colors shadow-sm" data-id="element-249">
              <Phone className="h-4 w-4 mr-2" data-id="element-250" />
              WhatsApp Us
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-251">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-white hover:text-green-200 p-2" data-id="element-252">
              {isMobileMenuOpen ? <X className="h-6 w-6" data-id="element-253" /> : <Menu className="h-6 w-6" data-id="element-254" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && <div className="md:hidden bg-green-900 absolute top-full left-0 right-0 shadow-xl border-t border-green-800" data-id="element-255">
          <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-256">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="block px-3 py-3 text-base font-medium text-white hover:bg-green-800 rounded-md" data-id="element-257">
                {link.name}
              </a>)}
            <a href="https://wa.me/254720934332" target="_blank" rel="noopener noreferrer" className="block w-full text-center mt-4 px-4 py-3 border border-transparent text-base font-medium rounded-md text-green-900 bg-green-100 hover:bg-white" data-id="element-258">
              WhatsApp Us
            </a>
          </div>
        </div>}
    </header>;
}